import type { NavItem, Service, Product, Statistic } from '../types';

export const COMPANY_NAME = 'ISTATEC';
export const COMPANY_TAGLINE = 'Tech Consulting · Software · AI Solutions';
export const COMPANY_DESCRIPTION = 'Empowering businesses with cutting-edge technology consulting, software product development, and expert technical talent.';

export const NAV_ITEMS: NavItem[] = [
  {
    label: 'Services',
    href: '/services',
    children: [
      { label: 'GenAI Solutions', href: '/services/genai' },
      { label: 'Backend Development', href: '/services/backend' },
      { label: 'Frontend Development', href: '/services/frontend' },
      { label: 'Cloud Engineering', href: '/services/cloud' },
      { label: 'Data Engineering', href: '/services/data-engineering' },
      { label: 'Data Science & ML', href: '/services/data-science' },
      { label: 'Salesforce', href: '/services/salesforce' },
      { label: 'Cybersecurity', href: '/services/cybersecurity' },
    ],
  },
  {
    label: 'Solutions',
    href: '/solutions',
    children: [
      { label: 'Tech Consulting', href: '/solutions/consulting' },
      { label: 'Product Development', href: '/solutions/product-development' },
      { label: 'Staff Augmentation', href: '/solutions/staff-augmentation' },
      { label: 'Dedicated Teams', href: '/solutions/dedicated-teams' },
    ],
  },
  {
    label: 'Products',
    href: '/products',
  },
  {
    label: 'About',
    href: '/about',
  },
  {
    label: 'Careers',
    href: '/careers',
  },
  {
    label: 'Contact',
    href: '/contact',
  },
];

export const SERVICES: Service[] = [
  {
    id: 'genai',
    title: 'GenAI Solutions',
    description: 'Harness the power of generative AI to transform your business processes, automate workflows, and create intelligent applications.',
    icon: 'Sparkles',
    features: ['LLM Integration', 'Custom AI Models', 'AI-Powered Automation', 'Intelligent Chatbots'],
  },
  {
    id: 'backend',
    title: 'Backend Development',
    description: 'Robust, scalable backend architectures built with modern technologies to power your applications.',
    icon: 'Server',
    features: ['Microservices', 'API Development', 'Database Design', 'System Integration'],
  },
  {
    id: 'frontend',
    title: 'Frontend Development',
    description: 'Beautiful, responsive user interfaces that deliver exceptional user experiences across all devices.',
    icon: 'Layout',
    features: ['React/Next.js', 'Vue/Nuxt', 'Angular', 'Mobile-First Design'],
  },
  {
    id: 'cloud',
    title: 'Cloud Engineering',
    description: 'Design, migrate, and optimize your cloud infrastructure for maximum performance and cost efficiency.',
    icon: 'Cloud',
    features: ['AWS/Azure/GCP', 'DevOps & CI/CD', 'Kubernetes', 'Infrastructure as Code'],
  },
  {
    id: 'data-engineering',
    title: 'Data Engineering',
    description: 'Build robust data pipelines and infrastructure to collect, process, and store your business data at scale.',
    icon: 'Database',
    features: ['ETL Pipelines', 'Data Warehousing', 'Real-time Streaming', 'Data Governance'],
  },
  {
    id: 'data-science',
    title: 'Data Science & ML',
    description: 'Extract actionable insights from your data with advanced analytics and machine learning solutions.',
    icon: 'Brain',
    features: ['Predictive Analytics', 'ML Models', 'Business Intelligence', 'Computer Vision'],
  },
  {
    id: 'salesforce',
    title: 'Salesforce',
    description: 'End-to-end Salesforce implementation, customization, and integration services.',
    icon: 'Zap',
    features: ['Implementation', 'Custom Development', 'Integration', 'Support & Maintenance'],
  },
  {
    id: 'cybersecurity',
    title: 'Cybersecurity',
    description: 'Protect your digital assets with comprehensive security assessments and robust security implementations.',
    icon: 'Shield',
    features: ['Security Audits', 'Penetration Testing', 'Compliance', 'Security Architecture'],
  },
];

export const PRODUCTS: Product[] = [
  {
    id: 'finextract',
    name: 'FinExtract',
    tagline: 'AI-Powered Credit Card Statement Parser',
    description: 'Enterprise-grade API that extracts transactions, balances, and financial data from PDF statements with 99.9% accuracy.',
    url: 'https://finextract.istatec.com/',
    features: [
      'Parse credit card statements in seconds',
      '99.9% extraction accuracy',
      'Support for 50+ banks',
      'Enterprise-ready API',
      'SOC 2 compliant',
    ],
  },
];

export const STATISTICS: Statistic[] = [
  { label: 'Projects Delivered', value: '200', suffix: '+' },
  { label: 'Tech Experts', value: '150', suffix: '+' },
  { label: 'Client Satisfaction', value: '98', suffix: '%' },
  { label: 'Years Experience', value: '10', suffix: '+' },
];

export const TECH_STACK = [
  'React', 'Node.js', 'Python', 'TypeScript', 'AWS', 'Azure', 'GCP',
  'Kubernetes', 'Docker', 'PostgreSQL', 'MongoDB', 'Redis', 'Kafka',
  'TensorFlow', 'PyTorch', 'Salesforce', 'Java', 'Go', '.NET'
];

export const CONTACT_INFO = {
  email: 'support@istatec.com',
  address: 'GROUND FLOOR, QR NO B 1904, SECTOR 2, SIDE 4, SAIL CITY ROAD, Dhurwa, Ranchi, Jharkhand, India, 834004',
};

export const SOCIAL_LINKS = {
  linkedin: 'https://www.linkedin.com/company/istatec/',
  twitter: 'https://x.com/istatec_new',
  youtube: 'https://www.youtube.com/@istatec_new',
};

